module.exports = __webpack_public_path__ + "static/media/completed.a079b5d3.jpeg";